
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {BModal} from "bootstrap-vue";

    @Component
    export default class ConfirmWithCommentModal extends Vue {
        @Prop({required: true})
        title! : string;

        @Prop({required: true})
        actionButtonText! : string;

        @Prop({default: "primary"})
        buttonVariant!: string;

        @Prop({required: true})
        confirm!: (comment : string) => Promise<undefined>;
        
        comment = "";

        $refs!: {bmodal: BModal}
        
        cancel() {
            this.$refs.bmodal.hide();
            this.comment = "";
        }
        
        async confirmInner() {
            this.$refs.bmodal.hide(); // NOTE: This has to be before awaiting callback.
            await this.confirm(this.comment)
        }
        
        public show() {
            this.$refs.bmodal.show();
        }
    }
